var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-actions",class:{ 'theme--dark': _vm.$vuetify.theme.dark, 'ui-actions--full': !_vm.drawer }},[_c('div',{staticClass:"ui-actions__container",class:{
      'ui-actions__container--centered': _vm.centered,
      'ui-actions__container--large': _vm.large,
      'ui-actions__container--small': _vm.small,
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }